import styled from 'styled-components';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';

export const StyledSpectrumArrow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  background: theme.colors.neutral['200'],
  padding: '4px 8px',
  position: 'relative',
  marginLeft: 20,
  marginRight: 20,

  '&::before, &:after': {
    content: "''",
    position: 'absolute',
    width: 0,
    height: 0,
    top: -8,
    borderTop: '20px solid transparent',
    borderBottom: '20px solid transparent',
  },

  '&::before': {
    borderRight: `20px solid ${theme.colors.neutral['200']}`,
    borderRadius: theme.radii.medium,
    left: -20,
  },

  '&::after': {
    borderLeft: `20px solid ${theme.colors.neutral['200']}`,
    borderRadius: theme.radii.medium,
    right: -20,
  },
}));
